import React, { Component } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles/index';
import {
  Button,
  Card,
  CardContent,
  FormControl,
  SnackbarContent,
  Input,
  InputLabel,
  Typography,
} from '@material-ui/core';
import classNames from 'classnames';
import _ from 'lodash';
import { FuseAnimate } from '@fuse';
import { withApollo } from 'react-apollo';
import { toast } from 'react-toastify';

import { requireAuthentication } from '../../../auth';
import { VERIFY_TOKEN } from '../../../graphql/mutation';
import { CLIENT_KEY } from '../../../graphql/query';
import { setLoginToken } from '../../../utils';
import { irpcApiBaseUrl } from '../../../config';

const styles = _theme => ({
  root: {
    background: 'linear-gradient(0deg, rgba(39,64,138,1) 0%, rgba(38,161,208,1) 100%)',
  },
  card: {
    width: '100%',
    maxWidth: 550,
  },
});

class LoginPage extends Component {
  state = {
    username: '',
    password: '',
    remember: true,
    error: false,
    loading: false,
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      this.login();
    }
  };

  login = async () => {
    try {
      this.setState({ loading: true });
      const { client } = this.props;
      const { username, password } = this.state;
      const { clientKey } = (await client.query({
        query: CLIENT_KEY,
      })).data;

      const clientTokenResp = await axios.post(
        `${irpcApiBaseUrl}/api/account/authenticate`,
        {
          username,
          password,
        },
        {
          headers: {
            'x-client-key': clientKey,
          },
        }
      );

      const clientToken = get(clientTokenResp, 'data.data.token');
      const deepleTokenResp = await client.mutate({
        mutation: VERIFY_TOKEN,
        variables: { token: clientToken },
      });

      const deepleToken = get(deepleTokenResp, 'data.verifyClientToken');
      setLoginToken(deepleToken);
      window.location.reload();
    } catch (e) {
      toast.error('Wrong username or password');
      console.log('error occur');
      this.setState({ loading: false });
    }
  };

  handleChange = event => {
    this.setState(
      _.set(
        { ...this.state },
        event.target.name,
        event.target.type === 'checkbox' ? event.target.checked : event.target.value
      )
    );
  };

  render() {
    const { classes } = this.props;
    const { username, password, loading } = this.state;

    return (
      <div
        className={classNames(
          classes.root,
          'flex flex-col flex-auto flex-no-shrink items-center justify-center p-32'
        )}
      >
        <div className="flex flex-col items-center justify-center w-full">
          <FuseAnimate animation="transition.expandIn">
            <Card className={classes.card}>
              <CardContent
                className="flex flex-col items-center justify-center p-32"
                style={{ margin: '0 100px' }}
              >
                {this.state.error && (
                  <SnackbarContent
                    variant="warning"
                    aria-describedby="client-snackbar"
                    message="Login Failed, Please check your username or password."
                  />
                )}
                <img
                  className="w-128 m-32"
                  src="assets/images/logos/irpc_chatbot_icon.png"
                  alt="logo"
                />

                <Typography variant="subheading" className="mt-16">
                  Sign In
                </Typography>
                <Typography variant="subheading" className="mb-16">
                  with your IRPC Account
                </Typography>

                <form name="loginForm" noValidate className="flex flex-col justify-center w-full">
                  <FormControl className="mb-16" fullWidth required>
                    <InputLabel>Username</InputLabel>
                    <Input
                      type="username"
                      name="username"
                      value={username}
                      onChange={this.handleChange}
                    />
                  </FormControl>

                  <FormControl className="mb-16" fullWidth required>
                    <InputLabel>Password</InputLabel>
                    <Input
                      type="password"
                      name="password"
                      value={password}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                  <Button
                    variant="raised"
                    color="primary"
                    className="w-224 mx-auto mt-16 mb-32"
                    aria-label="LOG IN"
                    disabled={loading}
                    onKeyPress={this.onKeyPress}
                    onClick={this.login}
                  >
                    LOGIN
                  </Button>
                </form>
              </CardContent>
            </Card>
          </FuseAnimate>
        </div>
      </div>
    );
  }
}

export default requireAuthentication(
  withStyles(styles, { withTheme: true })(withApollo(LoginPage)),
  false
);



// WEBPACK FOOTER //
// ./src/main/content/login/LoginPage.js